import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FeedMainComponent } from './feeds/feed-main/feed-main.component';
import { FeedComponent } from './feeds/feed/feed.component';
import { FeedGridSelectorComponent } from './feeds/feed-grid-selector/feed-grid-selector.component';
import { FeedListComponent } from './feeds/feed-list/feed-list.component';
import { FeedDetailComponent } from './feeds/feed-detail/feed-detail.component';
import { FeedApiInstructionsComponent } from './feeds/feed-api-instructions/feed-api-instructions.component';
import { MetadataSearchResultsComponent } from './feeds/metadata-search-results/metadata-search-results.component';
import { NotFoundComponent } from './../shared/error-handling/not-found/not-found.component';
import { GeneralErrorComponent } from './../shared/error-handling/general-error/general-error.component';
import { FeedRssComponent } from './feeds/feed-rss/feed-rss.component';


export const appRoutes: Routes = [
    {
        path: '',
        component: FeedMainComponent,
        children: [
            {
                path: 'list',
                component: FeedListComponent
            },
            {
                path: '',
                redirectTo: '/list',
                pathMatch: 'full'
            },
            {
                path: 'feed/:feed/definition',
                component: FeedDetailComponent
            },
            {
                path: 'search',
                component: MetadataSearchResultsComponent
            }
        ]
    },
    {
        path: 'rss/:feed',
        component: FeedRssComponent
    },
    {
        path: 'instructions',
        component: FeedApiInstructionsComponent
    },
    {
        path: 'feed/:feed',
        component: FeedComponent
    },
    {
        path: 'feed/:feed/selector',
        component: FeedGridSelectorComponent
    },
    {
        path: '404',
        component: NotFoundComponent
    },
    {
        path: 'error',
        component: GeneralErrorComponent
    },

    {
        path: '**',
        redirectTo: '/404'
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes)
    ]
    ,
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/main/app-routing.module.ts